/**
 * NavItem Molecule Component
 * Navigation link with active states and hover effects
 */

import React from 'react';
import { Link } from '@/components/atoms/Link';
import { NavItemBlok } from '@/types';

export interface NavItemProps extends NavItemBlok {
  isActive?: boolean;
  variant?: 'header' | 'footer';
  className?: string;
}

export const NavItem: React.FC<NavItemProps> = ({
  text,
  link,
  isActive = false,
  variant = 'header',
  className = '',
}) => {
  const variantStyles = {
    header: isActive
      ? 'text-white'
      : 'text-gray-400 hover:text-white',
    footer: 'text-gray-350 hover:text-white',
  };

  return (
    <Link
      href={link.cached_url || link.url || '#'}
      target={link.target}
      className={`
        text-xs font-archivo font-bold transition-colors duration-200 tracking-wide
        ${variantStyles[variant]}
        ${className}
      `}
    >
      {text}
    </Link>
  );
};

export default NavItem;
